import { createTheme } from '@mui/material/styles';
import THEME_UTIL from 'utils/theme-util';

let theme = createTheme({
  typography: {
    fontFamily: [
      'SF Pro Display',
      'Roboto',
      'Poppins',
      'Khmer Busra high',
      '-apple-system',
      'Raleway',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#BB9300',
      light: '#F2C335',
      contrastText: '#fff',
    },
    secondary: {
      main: '#2E2200',
      light: '#58492B',
      dark: '#0D0000',
      contrastText: '#fff',
    },
    error: {
      main: '#F0142F',
      light: '#FF5C59',
      dark: '#B50007',
      contrastText: '#fff',
    },
    success: {
      main: '#16a34a',
      light: '#73FFB7',
      dark: '#009D59',
      contrastText: '#fff',
    },
    warning: {
      main: '#F99600',
      light: '#FFC747',
      dark: '#C06800',
      contrastText: '#fff',
    },
    info: {
      main: '#57B8FF',
      light: '#30C9EE',
      dark: '#0088CB',
      contrastText: '#fff',
    },
    text: {
      primary: '#09090b',
      secondary: '#71717a',
    },
    background: {
      paper: '#F5F6FA',
    },
    divider: '#E0E0E0',
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: '#09090b',
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'white',
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          borderRadius: 8,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-selected': {
            background: THEME_UTIL.goldGradientMain,
            color: 'white',
            backgroundSize: '200% 200%',
            animation: 'gradientAnimation 4s ease infinite',
            width: '100%',
          },
        },
      },
    },
  },
});
theme.shadows[1] = '0px 1px 4px #15223214';
theme.shadows[2] = '0px 1px 1px #15223214';

export default theme;
